import { Component, OnInit } from '@angular/core';
import { ConsorciosService } from '../../services/consorcios.service';
import { SucursalService } from '../../services/sucursal.service';
import { Consorcio } from '../../model/consorcio';
import { Sucursal } from '../../model/sucursal';


@Component({
  selector: 'app-sucursal-detail',
  templateUrl: './sucursal-detail.component.html',
  styleUrls: ['./sucursal-detail.component.css']
})
export class SucursalDetailComponent implements OnInit {

  public modoEdicion: boolean = false;


  public consorcio: Consorcio;

  public consorcios: Consorcio[];
  public sucursales: Sucursal[];

  public sucursalSeleccionada: Sucursal;
  public query: any;

  public filtro:string;
  
  constructor(
    private _consorcioService: ConsorciosService,
    private _sucursalService: SucursalService
  ) { }

  ngOnInit() {
    this.filtro = "";
    this.sucursales = [];
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.sucursalSeleccionada = new Sucursal();
    this.cargarConsorcios();
  }

  cargarConsorcios() {
    this.query = { "email": sessionStorage.getItem("login") };
    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
      });
  }

  cargarSucursales() {
    if (this.consorcio === null) {
      return;
    }
    this.query = { "email": sessionStorage.getItem("login"), "codigoConsorcio": this.consorcio.codigoConsorcio };
    this._sucursalService.getSucursalesUsuario(this.query)
      .subscribe(
      data => this.sucursales = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  agregarRegistro() {
    if (this.consorcio === undefined) {
      return;
    }
    this.sucursalSeleccionada = new Sucursal();
    this.modoEdicion = true;
  }

  regresar() {
    this.modoEdicion = false;
    this.cargarSucursales();
  }


  editarRegistro(sucursal: Sucursal) {
    this.sucursalSeleccionada = sucursal;
    this.modoEdicion = true;
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/sucursal-detail/sucursal-detail.component.ts